import theme from "src/theme";

export const ALL_EDITING_METRICS = [
  "avg_num_edits_per_heat",
  "avg_num_materials_edited_per_heat",
  "avg_num_basket_additions_per_heat",
  "avg_num_recipe_additions_per_heat",
  "avg_num_basket_removals_per_heat",
  "avg_num_recipe_removals_per_heat",
  "avg_num_materials_only_moved_per_heat",
] as const;

export type EditingMetric = (typeof ALL_EDITING_METRICS)[number];

export const METRIC_COLORS: Record<EditingMetric, string> = {
  avg_num_edits_per_heat: theme.palette.data.blue,
  avg_num_materials_edited_per_heat: theme.palette.data.green,
  avg_num_basket_additions_per_heat: theme.palette.data.orange,
  avg_num_recipe_additions_per_heat: theme.palette.data.pink,
  avg_num_basket_removals_per_heat: theme.palette.data.red,
  avg_num_recipe_removals_per_heat: theme.palette.data.lightblue,
  avg_num_materials_only_moved_per_heat: theme.palette.warning.main,
};

export const getMetricTranslationKey = (metric: EditingMetric): string => {
  const map: Record<EditingMetric, string> = {
    avg_num_edits_per_heat: "numEdits",
    avg_num_materials_edited_per_heat: "numMaterialsEdited",
    avg_num_basket_additions_per_heat: "numBasketAdditions",
    avg_num_recipe_additions_per_heat: "numRecipeAdditions",
    avg_num_basket_removals_per_heat: "numBasketRemovals",
    avg_num_recipe_removals_per_heat: "numRecipeRemovals",
    avg_num_materials_only_moved_per_heat: "numMaterialsOnlyMoved",
  };
  return map[metric];
};
